import { HHStack, HHTypography } from '@hinge-health/react-component-library';
import FileUploadOutlined from '@mui/icons-material/FileUploadOutlined';
import PriceChangeOutlined from '@mui/icons-material/PriceChangeOutlined';
import { useNavigate } from 'react-router-dom';
import { QuickActionButton } from '../../billing-tool/components/quick-action-button';
import { routes } from '../constants/strings/routes';

export const ACCOUNTING_HOME_TEST_ID = 'accounting-home-section';

const AccountingHomePage = (): JSX.Element => {
  const navigate = useNavigate();

  const actions = [
    {
      label: 'Subscription Revenue Recognition',
      ariaLabel: 'go to subscription revenue recognition',
      Icon: PriceChangeOutlined,
      path: `${routes.accounting.home}${routes.accounting.subscriptionEstimates}`,
    },
    {
      label: 'CSV Upload',
      ariaLabel: 'go to csv upload',
      Icon: FileUploadOutlined,
      path: `${routes.accounting.home}${routes.accounting.csvUpload}`,
    },
  ];

  return (
    <HHStack
      direction="column"
      sx={{ margin: 4 }}
      spacing={4}
      padding={4}
      data-testid={ACCOUNTING_HOME_TEST_ID}
    >
      <HHTypography hhVariant="section-title">Accounting</HHTypography>
      <HHStack
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(2, 1fr)',
            sm: 'repeat(3, 1fr)',
            md: 'repeat(5, 1fr)',
          },
          gap: 2,
        }}
      >
        {actions.map(action => (
          <QuickActionButton
            key={action.ariaLabel}
            label={action.label}
            ariaLabel={action.ariaLabel}
            Icon={action.Icon}
            onClick={(): void => navigate(action.path)}
          />
        ))}
      </HHStack>
    </HHStack>
  );
};

export default AccountingHomePage;
